import React,{useState} from 'react'
import {Link} from 'react-router-dom'
import useAsync from '../../hooks/useAsync';
import PlanServices from '../../services/PlanServices.js';
import UserStatus from './TogelButton/UserStatus';
import Modal from 'react-modal';
import DeleteButton from './Button/DeleteButton';
import PlanUpdate from './Update Model/PlanUpdate';


Modal.setAppElement('#root');
function Plan() {
  
    const { data, error, isLoading, run } = useAsync(PlanServices.getAllPlan);
    console.log(data)

    const [activeIndex, setActiveIndex] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedEdit, setSelectedEdit] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredData, setFilteredData] = useState(data?.data || []);

    const handleDelete = (help) => {
        setSelectedEdit(help);
        setIsDeleteModalOpen(true);
        toggleActionMenu(null);
      };

      
      const closeDeleteModal = () => {
        setIsDeleteModalOpen(false);
        setSelectedEdit(null);
      };

      const handleEditDetails = (help) => {
        setSelectedEdit(help);
        setIsEditModalOpen(true);
        toggleActionMenu(null);
      };

      const closeEditModal = () => {
        setIsEditModalOpen(false);
        setSelectedEdit(null);
      };
    
      


      const toggleActionMenu = (index) => {
        setActiveIndex(index === activeIndex ? null : index); // Toggle the active index
      };
  return (
    
    <div className="right_col" role="main">
    <div className="title-box">
      <h2>Plans List <span className="badge bg-orange">{data?.data?.length}</span></h2>
      <div className="container-box-top-header-right d-flex">
        <Link className="round-add-btn" to="/admin/add-plan"><img src="img/plus.svg" alt="" /></Link>
      </div>
    </div>
    <div className="sub-title-box">
      <div className="sub-title-box-left">
        <p>Plans List</p>
      </div>
      <div className="sub-title-box-right">
        <button className="excel-btn"><img src="img/excel.svg" />Download</button>
      </div>
    </div>
    <div className="container-box px-0 user-manager">
      <div className="container-box-top-header px-4">
        <div className="container-box-top-header-left-2">
          <input type="search" name="search" placeholder="Search" />
          <button className="search-btn">Search</button>
        </div>
      </div>
      <div className="container-box-inner">
        <table id="example" className="table table-striped" style={{width: '100%'}}>
          <thead>
            <tr>
              <th>Package Name</th>
              <th>Amount</th>
              <th>User Type</th>
              <th>Package Type</th>
              <th>validity</th>
              <th>status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
          {data?.data?.map((plan, index) => (
            <tr>
              <td><span className="usertype">{plan?.name}</span></td>
              <td>{plan?.price}</td>
              <td>{plan?.usertype}</td>
              <td>{plan?.packageType}</td>
              <td>{plan?.validity}</td>
              <td className="status-toggle"><UserStatus user={plan} page={"plan"} onSuccess={run} /></td>
              <td>
              <div className="action_toggle_outer">
                        <button
                          className="action_toggle"
                          onClick={() => toggleActionMenu(index)}
                        >
                          <i className="fa fa-ellipsis-v" />
                        </button>
                        {activeIndex === index && (
                          <div className="action_toggle_content product-edit show d-block">
                            <ul className="list-unstyled">
                              <li><button className="close_toggle" onClick={() => toggleActionMenu(null)}><i className="fa fa-close" /></button></li>
                              <li><button className="edit" onClick={() => handleEditDetails(plan)}>Edit</button></li>
                              <li><button className="reject" onClick={() => handleDelete(plan)}>Delete</button></li>
                            </ul>
                          </div>
                        )}
                      </div>
                
              </td>
            </tr>
          ))}
          </tbody>
        </table>
      </div>
    </div>
    <Modal
          isOpen={isEditModalOpen}
          onRequestClose={closeEditModal}
          contentLabel="User Details"
          className="modal-content"
          overlayClassName="modal-overlay"
        >
          <PlanUpdate notification={selectedEdit} closeModal={closeEditModal} onSuccess={run} />
        </Modal>
    <Modal
          isOpen={isDeleteModalOpen}
          onRequestClose={closeDeleteModal}
          contentLabel="Delete Confirmation"
          className="modal-content"
          overlayClassName="modal-overlay"
        >
          <DeleteButton data={selectedEdit} page="plan" closeModal={closeDeleteModal} onSuccess={run} />
        </Modal>
  </div>
  )
}

export default Plan